import { uiNotification } from "../../../services/UINotificationService";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { authService } from "../../../services/AuthService";
import { useResend2FaOtpMutation } from "../../../api/mutations/useResend2FaOtpMutation";
import { extractApiError } from "../../../utilities/api";

export function useResendOtp() {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  const { mutateAsync, isLoading } = useResend2FaOtpMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(t([`error.${message}`, "error.sendOtp"]));
    },
    onSuccess: () => {
      uiNotification.success(t("success.otpResent"));
    },
  });

  const initiate = async () => {
    return mutateAsync({
      method: authService.getPreLoginData().twoFactorType,
      "2fa_resend_token": authService.getPreLoginData().resendToken2Fa,
      wpuId: authService.getPreLoginData().wpuId,
    });
  };

  return {
    initiate: async () => {
      return initiate();
    },
    isLoading,
  };
}
